"use client"

import { useQueryHospitalReviewAnalysis, useQueryHospitalSubjectsAnalysis } from "@/entities/hospital/hooks/queries"
import { useFeaturesHospitalDataStore, useFeaturesHospitalStore } from "@/features/hospital/model/store"
import { Typography } from "@/shared/ui/atoms"
import { CustomButton } from "@/shared/ui/molecules"
import { useTranslations } from "next-intl"
import { useHospitalOriginId } from "@/entities/hospital/model/hospital-origin-id"

const ReviewFilterModalTabs = () => {
  const t = useTranslations()
  const hospitalOriginId = useHospitalOriginId()
  const { selectedReviewFilterTab, setSelectedReviewFilterTab } = useFeaturesHospitalStore()
  const { selectedTreatmentCaseFilterData, selectedDetailFilterData } = useFeaturesHospitalDataStore()

  const {data: subjectsAnalysis = []} = useQueryHospitalSubjectsAnalysis(hospitalOriginId)
  const {data: reviewAnalysis = []} = useQueryHospitalReviewAnalysis(hospitalOriginId)

  const getSelectedTabClassName = (tab: "detail" | "treatmentCase") => {
    return selectedReviewFilterTab === tab ? "border-b-2 border-gray-900 pb-[10px]" : "border-b border-gray-200 pb-[11px]"
  }

  const getSelectedTabTextClassName = (tab: "detail" | "treatmentCase") => {
    return selectedReviewFilterTab === tab ? "text-gray-900" : "text-gray-400"
  }

  return (
    <div className="w-full flex items-center">
      {subjectsAnalysis.length > 0 && <CustomButton
        className={`flex-1 flex items-center justify-center pt-[6px] ${getSelectedTabClassName("treatmentCase")}`}
        onClick={() => setSelectedReviewFilterTab("treatmentCase")}
      >
        <Typography size={16} lineHeight={22} className={`relative w-fit font-semibold text-center ${getSelectedTabTextClassName("treatmentCase")}`}>
          {t("filter.subject")}
          {selectedTreatmentCaseFilterData?.treatment && (
            <span className="bg-[#FF6B6B] w-[5px] h-[5px] rounded-full absolute top-0 -right-2" />
          )}
        </Typography>
      </CustomButton>}
      {reviewAnalysis.length > 0 && <CustomButton
        className={`flex-1 flex items-center justify-center pt-[6px] ${getSelectedTabClassName("detail")}`}
        onClick={() => setSelectedReviewFilterTab("detail")}
      >
        <Typography size={16} lineHeight={22} className={`relative w-fit font-semibold text-center ${getSelectedTabTextClassName("detail")}`}>
          {t("filter.detail")}
          {selectedDetailFilterData.minor && (
            <span className="bg-[#FF6B6B] w-[5px] h-[5px] rounded-full absolute top-0 -right-2" />
          )}
        </Typography>
      </CustomButton>}
    </div>
  )
}

export default ReviewFilterModalTabs

